import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel } from 'swiper';
import { useIsMobile } from "../../hooks";
import { configColor, getPathByLink, navigateTo } from "@/utils";
import { useEffect, useMemo, useState } from "react";
import { ICardResponseDTO } from "../../interfaces/IVisoreCarouselDTO";
import { useTranslation } from "react-i18next";
import { getCDNProducts, ICDNProduct } from '@/utils/getCDNToken';

const Chip = dynamic(() => import("../ChipList/Chip"), { ssr: false });

import DOMPurify from "isomorphic-dompurify";
import ProductCard from "../Card/ProductCard";
import useDataCard from "../../hooks/useDataCard";
import ModuleComponentProps from "../../interfaces/ModuleComponent";
import dynamic from 'next/dynamic';
import React from 'react';

import "swiper/css";
import "swiper/css/free-mode";

const VisoreCarousel: React.FC<ModuleComponentProps> = ({ data, language }: ModuleComponentProps) => {

    const moduleData = data;
    const { i18n, t } = useTranslation();
    const lang = language? language : i18n.language;
    const [isMobile] = useIsMobile();
    const [widgetList, setWidgetList] = useState<string[]>([]);
    const [widgetDetail, setWidgetDetail] = useState<ICDNProduct[]>([]);

    const cardUrlList = useMemo(() => {
        return moduleData?.data?.lstCard?.map((item: { xconCard: { targeturl: any; }; }) => {
            return item.xconCard.targeturl
        }) || []
    }, [moduleData])

    const dataCard = useDataCard<ICardResponseDTO[]>({ urls: cardUrlList });

    if (moduleData.data.grpCardType == "grpAutomatismMarketplace") {

        useEffect(() => {
            // Determina il channel_id e la categoria in base all'aeroporto
            const isMalpensa = process.env.NEXT_PUBLIC_AIRPORT_REFERENCE?.toLowerCase() === 'malpensa';
            const channelId = isMalpensa
                ? process.env.NEXT_PUBLIC_CDN_CHANNEL_ID_MXP
                : process.env.NEXT_PUBLIC_CDN_CHANNEL_ID_LIN;
            const categoryId = isMalpensa
                ? (process.env.NEXT_PUBLIC_CDN_CATEGORY_ID_MXP || '51')
                : (process.env.NEXT_PUBLIC_CDN_CATEGORY_ID_LIN || '203');

            if (!channelId) {
                console.error('[VisoreCarousel] Missing CDN channel ID for current airport');
                return;
            }

            // Recupera i prodotti filtrati per lingua e categoria
            getCDNProducts(channelId, lang, categoryId)
                .then((products) => {
                    console.log(`[VisoreCarousel] Fetched ${products.length} products from CDN (locale: ${lang}, category: ${categoryId})`);

                    if (products.length > 0) {
                        console.log('[VisoreCarousel] Sample product:', products[0]);
                    }

                    // Limita a max 20 prodotti per non sovraccaricare il carousel
                    const limitedProducts = products.slice(0, 20);
                    setWidgetDetail(limitedProducts);
                })
                .catch(error => {
                    console.error('[VisoreCarousel] getCDNProducts error -> ', error);
                });
        }, [lang])
    }

    function showPrice(id: string, tax_class_id: number, price: number, variants: any) {
        let found = false

        variants.forEach((el: any) => {
            if(el.sale_price === price) found = true
                else found = false
        })

        if(id === "price"){
            if(tax_class_id === 0 && found) return('€' + (price / 1.22).toFixed(2))
            else if (found) return ('€' + price)
            else return (findLowestPrice(variants))
        } else {
            if(tax_class_id === 0) return ('€' + price.toString()) 
            else if (!found) return ('€' +(price / 1.22).toFixed(2))
            else return ""
        }
    }

    function findLowestPrice(variants: any) {
        let lowest = variants[0].sale_price;
        variants.forEach((el: any) => {if(el.sale_price < lowest) lowest = el.sale_price})

        return ('€' +(lowest/ 1.22).toFixed(2));
    }

    var resourcename: string | undefined = "";
    var mediaserverpath: string | undefined = "";

    if (isMobile) {

        resourcename = moduleData?.data?.upiImageMobile && moduleData?.data?.upiImageMobile.resourcename ? moduleData?.data?.upiImageMobile.resourcename : "";
        mediaserverpath = moduleData?.data?.upiImageMobile && moduleData?.data?.upiImageMobile.mediaserverpath ? moduleData?.data?.upiImageMobile.mediaserverpath : "";
    } else {

        resourcename = moduleData?.data?.upiImageDesk && moduleData?.data?.upiImageDesk.resourcename ? moduleData?.data?.upiImageDesk.resourcename : "";
        mediaserverpath = moduleData?.data?.upiImageDesk && moduleData?.data?.upiImageDesk.mediaserverpath ? moduleData?.data?.upiImageDesk.mediaserverpath : "";
    }

    const imagePath = mediaserverpath + '/' + resourcename;

    const bgBtnColor = moduleData?.data?.enuBackgroundCta ? configColor('bg', moduleData?.data?.enuBackgroundCta) : "bg-white";
    const txtColor = moduleData?.data?.enuTitleColor ? configColor('text', moduleData?.data?.enuTitleColor) : "text-black";

    return (
        <div style={{ backgroundImage: `url(${imagePath})` }} className="bg-cover bg-no-repeat bg-center desk:h-[550px] h-auto" >
            <div className="max-w-cont-2 mx-auto h-full w-full flex flex-col desk:flex-row">
                <div className={`mt-9 desk:mt-36 mb-14 desk:mb-56 desk:flex-col flex-[1.25] ${txtColor} px-6`}>
                    {moduleData?.data?.lblTitle && moduleData?.data?.lblTitle[lang] ?
                        <h1
                            className='text-2xl desk:text-3xl font-semibold mb-2.5 font-secondary uppercase'
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(moduleData?.data?.lblTitle && moduleData?.data?.lblTitle[lang] ? moduleData?.data?.lblTitle[lang] : '') }}>
                        </h1>
                        : null}

                    {moduleData?.data?.lblSubtitle && moduleData?.data?.lblSubtitle[lang] ?
                        <h2
                            className="mb-7 desk:mb-10"
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(moduleData?.data?.lblSubtitle && moduleData?.data?.lblSubtitle[lang] ? moduleData?.data?.lblSubtitle[lang] : '') }}>
                        </h2>
                        : null}

                    {moduleData?.data?.lblLabelCta && moduleData?.data?.lblLabelCta[lang] ?
                        <div>
                            <Chip
                                text={moduleData?.data?.lblLabelCta[lang]}
                                bgColor={bgBtnColor}
                                txtColor={bgBtnColor === "bg-[#FFFFFF]" ? "text-black" : "text-white"}
                                width="w-full"
                                onClick={() => { }}
                                hrefPath={getPathByLink(moduleData?.data, lang)}
                                target={moduleData?.data?.flgTarget ? "_blank" : "_self"}
                            />
                        </div>
                        : null}
                </div>
                
                <div className="flex flex-[3] mb-12 desk:mb-0 text-black h-full desh:h-[550px]">
                    <Swiper
                        direction={isMobile ? "horizontal" : "vertical"}
                        freeMode={true}
                        modules={[isMobile ? FreeMode : FreeMode, Mousewheel]}
                        slidesPerView={"auto"}
                        spaceBetween={20}
                        mousewheel={isMobile ? false : true}
                        slidesOffsetBefore={isMobile ? 26 : 29}
                        slidesOffsetAfter={isMobile ? 26 : 49}
                    >
                        {moduleData.data.grpCardType == "grpAutomatismMarketplace" ?
                            
                            <React.Fragment>
                                <SwiperSlide className="h-3 w-3"></SwiperSlide>
                                    
                                    {widgetDetail?.length > 0 ? 
                                        
                                        widgetDetail.map((product: ICDNProduct, index: number) => {

                                        let widthCarousel = isMobile ? "!w-auto" : "";

                                        if (!product.is_visible && product.inventory_level === 0) {
                                            return null;
                                        }

                                        const productUrl = product.custom_url?.url || `/products/${product.id}`;
                        const isMalpensaUrl = process.env.NEXT_PUBLIC_AIRPORT_REFERENCE?.toLowerCase() === 'malpensa';
                        const boutiqueSite = isMalpensaUrl
                            ? process.env.NEXT_PUBLIC_SITE_BOUTIQUE_MXP
                            : process.env.NEXT_PUBLIC_SITE_BOUTIQUE_LIN;
                        const fullUrl = lang === 'it'
                            ? `${boutiqueSite}${productUrl}`
                            : `${boutiqueSite}/en${productUrl}`;
                                        const imageUrl = product.image?.url_thumbnail || product.primary_image?.url_thumbnail || '';

                                        return (
                                            <SwiperSlide key={product.id} className={`!h-auto ${widthCarousel} overflow-hidden`}>
                                                <ProductCard
                                                    title={product.name}
                                                    titleColor="black"
                                                    onClick={() => window.open(fullUrl)}
                                                    imgUrl={imageUrl}
                                                    subTitle={product.brand_name || ''}
                                                    subTitleColor="black"
                                                    price={product.tax_class_id? '€' + product.price?.toFixed(2) : '€' + (product.price / 1.22).toFixed(2) }
                                                    oldPrice={product.tax_class_id? '' : '€' + product.price?.toString()}
                                                    labelCta={t('shop.book')}
                                                    bgCta="FFFFFF"
                                                />
                                            </SwiperSlide>
                                        )
                                        
                                    }) : <React.Fragment></React.Fragment>
                                }
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <SwiperSlide className="h-3 w-3"></SwiperSlide>
                                {dataCard?.map((card, index) => {
                                    let { mediaserverpath, resourcename } = !isMobile ? card?.data?.upiImageShoppingDesktop[lang] : card?.data?.upiImageShoppingMobile[lang];
                                    let imagePath = mediaserverpath + '/' + resourcename;
                                    let widthCarousel = isMobile ? "!w-auto" : "";

                                    return (
                                        <SwiperSlide key={card.data.metainfo.id} className={`!h-auto ${widthCarousel} overflow-hidden`}>
                                            <ProductCard
                                                imgUrl={imagePath}
                                                title={DOMPurify.sanitize(card?.data?.lblTitleShopping && card?.data?.lblTitleShopping[lang] ? card?.data?.lblTitleShopping[lang] : '')}
                                                titleColor={card?.data?.enuTitleColorShopping ? configColor('text', card?.data?.enuTitleColorShopping) : "text-white"}
                                                subTitle={DOMPurify.sanitize(card?.data?.lblSubtitleShopping && card?.data?.lblSubtitleShopping[lang] ? card?.data?.lblSubtitleShopping[lang] : '')}
                                                subTitleColor={card?.data?.enuSubtitleColorShopping ? configColor('text', card?.data?.enuSubtitleColorShopping) : "text-white"}
                                                price={showPrice("price", widgetDetail[index].tax_class_id, widgetDetail[index].price, widgetDetail[index].variants)}
                                                oldPrice={showPrice("oldPrice", widgetDetail[index].tax_class_id, widgetDetail[index].price, widgetDetail[index].variants)}
                                                labelCta={card?.data?.lblLabelCtaShopping && card?.data?.lblLabelCtaShopping[lang] ? card?.data?.lblLabelCtaShopping[lang] : ""}
                                                bgCta={card?.data?.enuBackgroundCtaShopping ? configColor('bg', card?.data?.enuBackgroundCtaShopping) : "bg-lightblue"}
                                                onClick={() => navigateTo(card?.data?.lblLinkCtaShopping[lang], card?.data?.flgTargetCtaShopping)} />
                                        </SwiperSlide>
                                    )
                                })}
                            </React.Fragment>
                        }
                    </Swiper>
                </div>
            </div>
        </div>
    )
}

export default VisoreCarousel;
